import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import styles from './ContactOrganizerInstructions.module.scss';

const ContactOrganizerInstructions: React.FC = () => {
  return (
    <div className={styles['instructions-container']}>
      <Typography variant="body-lg-bold" className={styles.text}>
        How to contact the event organizer
      </Typography>
      <ol className={styles['instruction-list']}>
        <Typography variant="body-md" className={styles.text}>
          <li>Go to the event page</li>
        </Typography>
        <Typography variant="body-md" className={styles.text}>
          <li>Scroll down and select Contact</li>
        </Typography>
        <Typography variant="body-md" className={styles.text}>
          <li>Select Contact the organizer</li>
        </Typography>
      </ol>
    </div>
  );
};

export default ContactOrganizerInstructions;
